var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 116c0 6.627-5.373 12-12 12H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h104c6.627 0 12 5.373 12 12v104z",
    fill: "#fe4d01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.047 61H128v65a2 2 0 0 1-2 2H61.62l3.363-17.795c.283-1.498-1.15-2.763-2.618-2.357-4.587 1.269-10.894 2.571-13.721 1.598C44.151 107.9 41.51 95.746 47 87.5c2.676-4.02 7.89-2.966 12.232-.518 1.838 1.036 5.58-.844 5.314-2.937l-2.641-20.794A2 2 0 0 1 63.89 61h20.685a2 2 0 0 1 2 2v10.879a7.74 7.74 0 0 0 7.736 7.736 7.74 7.74 0 0 0 7.736-7.736V63a2 2 0 0 1 2-2z",
    fill: "#f6f4ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.d877fdf00df76194f6e662fdb24dc747.svg";
export { ForwardRef as ReactComponent };